export default __webpack_public_path__ + "static/media/Well-BeingShop@2x.bef3a392.png";